
<h2>
    <span class="pl-2 pr-2">
        <a (click)="goBack()" class="d-inline-flex" href="javascript:void(0)">
            <img src="assets/images/grid-back.png">
        </a>
    </span>{{resource | titlecase}} Resource Definition
</h2>
<div class="main-container-body">
    <!-- <json-editor *ngIf="data" [options]="editorOptions" [data]="data" (change)="getData($event)"></json-editor> -->
    NOTE : JSON EDITOR IS REMOVED
    {{data | json}}
</div>